/**
 * KiekkoKingi section controller: facts
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
        const sectionId = kkScript.dataset.sectionId;
        const rootId = kkScript.dataset.rootId;
        const controllers = window.__kiekkokingFactsControllers = window.__kiekkokingFactsControllers || {};
  
        if (controllers[sectionId] && typeof controllers[sectionId].destroy === 'function') {
          controllers[sectionId].destroy();
        }
  
        const initFacts = () => {
          const root = document.getElementById(rootId);
          if (!root || root.dataset.factsInitialized === 'true') return;
  
          root.dataset.factsInitialized = 'true';
          root.classList.add('is-js-enabled');
  
          const animateNumbers = root.dataset.animateNumbers === 'true';
          const animateEntry = root.dataset.entryAnimation === 'true';
          const duration = Math.min(1200, Math.max(500, Number(root.dataset.animationDuration) || 900));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const animationFrames = [];
          let observer;
          let hasRevealed = false;
  
          const numberParts = (element) => {
            const original = element.dataset.factValue || element.textContent || '';
            const match = original.match(/\d[\d \u00a0]*/);
            if (!match || original.slice(0, match.index).trim() !== '') return null;
  
            const target = Number(match[0].replace(/[ \u00a0]/g, ''));
            if (!Number.isFinite(target) || target <= 0) return null;
  
            return {
              original,
              target,
              grouped: /[ \u00a0]/.test(match[0]),
              suffix: original.slice(match.index + match[0].length)
            };
          };
  
          const formatNumber = (value, grouped) => {
            const rounded = Math.round(value);
            if (!grouped) return String(rounded);
            return rounded.toLocaleString('fi-FI').replace(/\u00a0/g, ' ');
          };
  
          const animateFact = (element) => {
            const parts = numberParts(element);
            if (!parts) return;
  
            const startTime = performance.now();
            element.textContent = `${formatNumber(0, parts.grouped)}${parts.suffix}`;
  
            const step = (timestamp) => {
              const progress = Math.min(1, (timestamp - startTime) / duration);
              const eased = 1 - Math.pow(1 - progress, 3);
              element.textContent = `${formatNumber(parts.target * eased, parts.grouped)}${parts.suffix}`;
  
              if (progress < 1) {
                animationFrames.push(window.requestAnimationFrame(step));
              } else {
                element.textContent = parts.original;
              }
            };
  
            animationFrames.push(window.requestAnimationFrame(step));
          };
  
          const reveal = () => {
            if (hasRevealed) return;
            hasRevealed = true;
            root.classList.add('is-visible');
  
            if (animateNumbers && !reducedMotion.matches) {
              root.querySelectorAll('[data-fact-number]').forEach(animateFact);
            }
  
            if (observer) observer.disconnect();
          };
  
          if (reducedMotion.matches || !('IntersectionObserver' in window)) {
            reveal();
          } else {
            observer = new IntersectionObserver((entries) => {
              if (entries.some((entry) => entry.isIntersecting)) reveal();
            }, { threshold: 0.16 });
            observer.observe(root);
          }
  
          if (!animateEntry) root.classList.add('is-visible');
  
          root.factsCleanup = () => {
            if (observer) observer.disconnect();
            animationFrames.forEach((frame) => window.cancelAnimationFrame(frame));
            delete root.factsCleanup;
            delete root.dataset.factsInitialized;
          };
        };
  
        const sectionMatches = (event) => event.detail && String(event.detail.sectionId) === String(sectionId);
        const handleSectionLoad = (event) => {
          if (sectionMatches(event)) initFacts();
        };
        const handleSectionUnload = (event) => {
          if (!sectionMatches(event)) return;
          const root = document.getElementById(rootId);
          if (root && typeof root.factsCleanup === 'function') root.factsCleanup();
        };
        const destroy = () => {
          const root = document.getElementById(rootId);
          if (root && typeof root.factsCleanup === 'function') root.factsCleanup();
          document.removeEventListener('shopify:section:load', handleSectionLoad);
          document.removeEventListener('shopify:section:unload', handleSectionUnload);
          if (controllers[sectionId] && controllers[sectionId].destroy === destroy) {
            delete controllers[sectionId];
          }
        };
  
        initFacts();
        document.addEventListener('shopify:section:load', handleSectionLoad);
        document.addEventListener('shopify:section:unload', handleSectionUnload);
        controllers[sectionId] = { destroy };
      })();
})();